import { useMemo, useState } from "react";
import { memes } from "@/mocks/comics";

const filterList = ["全部", "沙雕日常", "神吐槽", "梗图段子", "无厘头剧场"];

export default function Memes() {
  const [keyword, setKeyword] = useState("");
  const [active, setActive] = useState("全部");

  const list = useMemo(() => {
    return memes.filter((m) => {
      const matchCat = active === "全部" || m.category === active;
      const kw = keyword.trim().toLowerCase();
      const matchKw = !kw || m.title.toLowerCase().includes(kw) || m.category.toLowerCase().includes(kw);
      return matchCat && matchKw;
    });
  }, [keyword, active]);

  return (
    <section id="memes" className="w-full bg-background-100/60 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-5 md:flex-row md:items-end">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-xs text-primary-700">
              <i className="ri-emoji-sticker-line"></i> 持续更新
            </span>
            <h2 className="mt-3 font-heading text-2xl text-foreground-950 md:text-4xl">
              梗图段子在线看
            </h2>
            <p className="mt-2 max-w-xl text-sm text-foreground-600 md:text-base">
              一图胜千言，存图到手软。支持关键词搜索和分类筛选，随时发现新的快乐源泉。
            </p>
          </div>

          <div className="relative w-full md:w-72">
            <i className="ri-search-line absolute left-3.5 top-1/2 -translate-y-1/2 text-sm text-foreground-500"></i>
            <input
              type="text"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜梗图、搜段子…"
              className="w-full rounded-full border border-background-300 bg-background-50 py-2.5 pl-10 pr-4 text-sm text-foreground-900 outline-none transition-colors focus:border-primary-400"
            />
          </div>
        </div>

        <div className="mt-7 flex flex-wrap items-center gap-2 rounded-full bg-background-200/70 p-1 px-1 py-1 w-fit">
          {filterList.map((f) => (
            <button
              key={f}
              type="button"
              onClick={() => setActive(f)}
              className={`whitespace-nowrap rounded-full px-4 py-1.5 text-sm transition-colors ${
                active === f
                  ? "bg-primary-500 text-background-50"
                  : "text-foreground-600 hover:bg-background-50"
              }`}
            >
              {f}
            </button>
          ))}
        </div>

        {list.length === 0 ? (
          <div className="mt-10 rounded-2xl border border-dashed border-background-300 bg-background-50 py-16 text-center">
            <i className="ri-search-eye-line text-4xl text-foreground-300"></i>
            <p className="mt-3 text-sm text-foreground-500">没有找到相关梗图，换个关键词试试吧</p>
          </div>
        ) : (
          <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {list.map((m) => (
              <article
                key={m.id}
                className="group overflow-hidden rounded-2xl border border-background-200 bg-background-50 transition-transform duration-300 hover:-translate-y-1"
              >
                <div className="relative aspect-[16/10] w-full overflow-hidden">
                  <img
                    src={m.image}
                    alt={`韩国歪歪漫画-${m.title}`}
                    title={`${m.title}-梗图段子`}
                    className="h-full w-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
                  />
                  <span className="absolute right-3 top-3 rounded-full bg-background-950/55 px-3 py-1 text-xs text-background-50 backdrop-blur-sm">
                    {m.category}
                  </span>
                </div>
                <div className="flex items-center justify-between p-4 md:p-5">
                  <h3 className="font-heading text-base text-foreground-950">{m.title}</h3>
                  <span className="inline-flex items-center gap-1 text-xs text-foreground-500">
                    <i className="ri-heart-3-fill text-accent-500"></i> {m.likes.toLocaleString()}
                  </span>
                </div>
              </article>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}